export default "__VITE_ASSET__DEr5Ieua__"